import { render, staticRenderFns } from "./commercialeDistributoreDettaglio.vue?vue&type=template&id=e8c7f56a&"
import script from "./commercialeDistributoreDettaglio.vue.ts?vue&type=script&lang=ts&"
export * from "./commercialeDistributoreDettaglio.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports